import { render, staticRenderFns } from "./SupportPromptTemplateTest.vue?vue&type=template&id=4e4e52dd&scoped=true"
import script from "./SupportPromptTemplateTest.vue?vue&type=script&lang=js"
export * from "./SupportPromptTemplateTest.vue?vue&type=script&lang=js"
import style0 from "./SupportPromptTemplateTest.vue?vue&type=style&index=0&id=4e4e52dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4e52dd",
  null
  
)

export default component.exports